import { render, staticRenderFns } from "./AddFlightV2.vue?vue&type=template&id=80987406"
import script from "./AddFlightV2.vue?vue&type=script&lang=js"
export * from "./AddFlightV2.vue?vue&type=script&lang=js"
import style0 from "./AddFlightV2.vue?vue&type=style&index=0&id=80987406&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports